<div *ngIf="results && (results.ships || results.events)">
  <div class="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
    <div class="text-center mb-24">
      <h1
        class="
          mt-1
          text-4xl
          font-extrabold
          text-blue-800
          sm:text-5xl sm:tracking-tight
          lg:text-6xl
        "
      >
        Suchergebnisse
      </h1>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 md:gap-x-4">
      <div
        class="mt-12"
        *ngIf="results && results.ships && results.ships.length > 0"
      >
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Schiffe</h2>
        <span *ngFor="let ship of results.ships">
          <div class="flex items-center my-4">
            <h3 class="text-xl text-gray-700">{{ ship.keyword }}&nbsp;</h3>
            <span class="text-gray-500"
              >({{ ship.imgs.count }}
              <span *ngIf="ship.imgs.count != 1">Bilder</span>
              <span *ngIf="ship.imgs.count == 1">Bild</span>)
            </span>
            <button
              [routerLink]="['/keyword', ship.id]"
              class="
                ml-2
                inline-flex
                items-center
                my-2
                px-4
                py-1
                border border-gray-300
                shadow-sm
                text-base
                font-medium
                rounded-md
                text-gray-700
                bg-white
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-400
              "
              *ngIf="ship.imgs.count > 5"
            >
              Mehr anzeigen
            </button>
          </div>
          <ul
            role="list"
            class="
              grid grid-cols-3
              gap-x-2 gap-y-8
              sm:grid-cols-3 sm:gap-x-3
              lg:grid-cols-4
              xl:gap-x-4
            "
          >
            <li
              [routerLink]="['/img', img.id]"
              *ngFor="let img of ship.imgs.data"
            >
              <div
                class="
                  group
                  block
                  w-full
                  aspect-w-10 aspect-h-7
                  shadow-xl
                  rounded-lg
                  bg-gray-100
                  focus-within:ring-2
                  focus-within:ring-offset-2
                  focus-within:ring-offset-gray-100
                  focus-within:ring-blue-500
                  overflow-hidden
                "
              >
                <img
                  class="
                    object-cover
                    pointer-events-none
                    group-hover:opacity-75
                  "
                  [src]="imgRoot + img?.file_name"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </span>
      </div>
      <div
        class="mt-12"
        *ngIf="results && results.places && results.places.length > 0"
      >
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Orte</h2>
        <span *ngFor="let place of results.places">
          <div class="flex items-center my-4">
            <h3 class="text-xl text-gray-700">{{ place.keyword }}&nbsp;</h3>
            <span class="text-gray-500"
              >({{ place.imgs.count }}
              <span *ngIf="place.imgs.count != 1">Bilder</span>
              <span *ngIf="place.imgs.count == 1">Bild</span>)
            </span>
            <button
              [routerLink]="['/keyword', place.id]"
              class="
                ml-2
                inline-flex
                items-center
                my-2
                px-4
                py-1
                border border-gray-300
                shadow-sm
                text-base
                font-medium
                rounded-md
                text-gray-700
                bg-white
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-400
              "
              *ngIf="place.imgs.count > 5"
            >
              Mehr anzeigen
            </button>
          </div>
          <ul
            role="list"
            class="
              grid grid-cols-3
              gap-x-2 gap-y-8
              sm:grid-cols-3 sm:gap-x-3
              lg:grid-cols-4
              xl:gap-x-4
            "
          >
            <li
              [routerLink]="['/img', img.id]"
              *ngFor="let img of place.imgs.data"
            >
              <div
                class="
                  group
                  block
                  w-full
                  aspect-w-10 aspect-h-7
                  shadow-xl
                  rounded-lg
                  bg-gray-100
                  focus-within:ring-2
                  focus-within:ring-offset-2
                  focus-within:ring-offset-gray-100
                  focus-within:ring-blue-500
                  overflow-hidden
                "
              >
                <img
                  class="
                    object-cover
                    pointer-events-none
                    group-hover:opacity-75
                  "
                  [src]="imgRoot + img?.file_name"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </span>
      </div>
      <div
        class="mt-12"
        *ngIf="results && results.events && results.events.length > 0"
      >
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Veranstaltungen</h2>
        <span *ngFor="let event of results.events">
          <div class="flex items-center my-4">
            <h3 class="text-xl text-gray-700">{{ event.keyword }}&nbsp;</h3>
            <span class="text-gray-500"
              >({{ event.imgs.count }}
              <span *ngIf="event.imgs.count != 1">Bilder</span>
              <span *ngIf="event.imgs.count == 1">Bild</span>)
            </span>
            <button
              [routerLink]="['/keyword', event.id]"
              class="
                ml-2
                inline-flex
                items-center
                my-2
                px-4
                py-1
                border border-gray-300
                shadow-sm
                text-base
                font-medium
                rounded-md
                text-gray-700
                bg-white
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-400
              "
              *ngIf="event.imgs.count > 5"
            >
              Mehr anzeigen
            </button>
          </div>
          <ul
            role="list"
            class="
              grid grid-cols-3
              gap-x-2 gap-y-8
              sm:grid-cols-3 sm:gap-x-3
              lg:grid-cols-4
              xl:gap-x-4
            "
          >
            <li
              [routerLink]="['/img', img.id]"
              *ngFor="let img of event.imgs.data"
            >
              <div
                class="
                  group
                  block
                  w-full
                  aspect-w-10 aspect-h-7
                  shadow-xl
                  rounded-lg
                  bg-gray-100
                  focus-within:ring-2
                  focus-within:ring-offset-2
                  focus-within:ring-offset-gray-100
                  focus-within:ring-blue-500
                  overflow-hidden
                "
              >
                <img
                  class="
                    object-cover
                    pointer-events-none
                    group-hover:opacity-75
                  "
                  [src]="imgRoot + img?.file_name"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </span>
      </div>

      <div
        class="mt-12"
        *ngIf="
          results && results.photographers && results.photographers.length > 0
        "
      >
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Fotografen</h2>
        <span *ngFor="let photographer of results.photographers">
          <div class="flex items-center my-4">
            <h3 class="text-xl text-gray-700">
              {{ photographer.keyword }}&nbsp;
            </h3>
            <span class="text-gray-500"
              >({{ photographer.imgs.count }}
              <span *ngIf="photographer.imgs.count != 1">Bilder</span>
              <span *ngIf="photographer.imgs.count == 1">Bild</span>)
            </span>
            <button
              [routerLink]="['/keyword', photographer.id]"
              class="
                ml-2
                inline-flex
                items-center
                my-2
                px-4
                py-1
                border border-gray-300
                shadow-sm
                text-base
                font-medium
                rounded-md
                text-gray-700
                bg-white
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-400
              "
              *ngIf="photographer.imgs.count > 5"
            >
              Mehr anzeigen
            </button>
          </div>
          <ul
            role="list"
            class="
              grid grid-cols-3
              gap-x-2 gap-y-8
              sm:grid-cols-3 sm:gap-x-3
              lg:grid-cols-4
              xl:gap-x-4
            "
          >
            <li
              [routerLink]="['/img', img.id]"
              *ngFor="let img of photographer.imgs.data"
            >
              <div
                class="
                  group
                  block
                  w-full
                  aspect-w-10 aspect-h-7
                  shadow-xl
                  rounded-lg
                  bg-gray-100
                  focus-within:ring-2
                  focus-within:ring-offset-2
                  focus-within:ring-offset-gray-100
                  focus-within:ring-blue-500
                  overflow-hidden
                "
              >
                <img
                  class="
                    object-cover
                    pointer-events-none
                    group-hover:opacity-75
                  "
                  [src]="imgRoot + img?.file_name"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </span>
      </div>

      <div
        class="mt-12"
        *ngIf="results && results.authors && results.authors.length > 0"
      >
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Autoren</h2>
        <span *ngFor="let author of results.authors">
          <div class="flex items-center my-4">
            <h3 class="text-xl text-gray-700">{{ author.keyword }}&nbsp;</h3>
            <span class="text-gray-500"
              >({{ author.imgs.count }}
              <span *ngIf="author.imgs.count != 1">Bilder</span>
              <span *ngIf="author.imgs.count == 1">Bild</span>)
            </span>
            <button
              [routerLink]="['/keyword', author.id]"
              class="
                ml-2
                inline-flex
                items-center
                my-2
                px-4
                py-1
                border border-gray-300
                shadow-sm
                text-base
                font-medium
                rounded-md
                text-gray-700
                bg-white
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-400
              "
              *ngIf="author.imgs.count > 5"
            >
              Mehr anzeigen
            </button>
          </div>
          <ul
            role="list"
            class="
              grid grid-cols-3
              gap-x-2 gap-y-8
              sm:grid-cols-3 sm:gap-x-3
              lg:grid-cols-4
              xl:gap-x-4
            "
          >
            <li
              [routerLink]="['/img', img.id]"
              *ngFor="let img of author.imgs.data"
            >
              <div
                class="
                  group
                  block
                  w-full
                  aspect-w-10 aspect-h-7
                  shadow-xl
                  rounded-lg
                  bg-gray-100
                  focus-within:ring-2
                  focus-within:ring-offset-2
                  focus-within:ring-offset-gray-100
                  focus-within:ring-blue-500
                  overflow-hidden
                "
              >
                <img
                  class="
                    object-cover
                    pointer-events-none
                    group-hover:opacity-75
                  "
                  [src]="imgRoot + img?.file_name"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </span>
      </div>

      <div
        class="mt-12"
        *ngIf="results && results.keywords && results.keywords.length > 0"
      >
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Stichwörter</h2>
        <span *ngFor="let keyword of results.keywords">
          <div class="flex items-center my-4">
            <h3 class="text-xl text-gray-700">{{ keyword.keyword }}&nbsp;</h3>
            <span class="text-gray-500"
              >({{ keyword.imgs.count }}
              <span *ngIf="keyword.imgs.count != 1">Bilder</span>
              <span *ngIf="keyword.imgs.count == 1">Bild</span>)
            </span>
            <button
              [routerLink]="['/keyword', keyword.id]"
              class="
                ml-2
                inline-flex
                items-center
                my-2
                px-4
                py-1
                border border-gray-300
                shadow-sm
                text-base
                font-medium
                rounded-md
                text-gray-00
                bg-white
                hover:bg-gray-50
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-blue-400
              "
              *ngIf="keyword.imgs.count > 5"
            >
              Mehr anzeigen
            </button>
          </div>
          <ul
            role="list"
            class="
              grid grid-cols-3
              gap-x-2 gap-y-8
              sm:grid-cols-3 sm:gap-x-3
              lg:grid-cols-4
              xl:gap-x-4
            "
          >
            <li
              [routerLink]="['/img', img.id]"
              *ngFor="let img of keyword.imgs.data"
            >
              <div
                class="
                  group
                  block
                  w-full
                  aspect-w-10 aspect-h-7
                  shadow-xl
                  rounded-lg
                  bg-gray-100
                  focus-within:ring-2
                  focus-within:ring-offset-2
                  focus-within:ring-offset-gray-100
                  focus-within:ring-blue-500
                  overflow-hidden
                "
              >
                <img
                  class="
                    object-cover
                    pointer-events-none
                    group-hover:opacity-75
                  "
                  [src]="imgRoot + img?.file_name"
                  alt=""
                />
              </div>
            </li>
          </ul>
        </span>
      </div>
    </div>
    <div
      class="mt-12"
      *ngIf="results && results.titles && results.titles.count > 0 && results.titles.data?.length > 0"
    >
      <div>
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Überschriften</h2>
        &nbsp;
        <span class="text-gray-500" style="position: relative; top: 26px"
          >({{ results.titles.count }}
          <span *ngIf="results.titles.count != 1">Bilder</span>
          <span *ngIf="results.titles.count == 1">Bild</span>)
        </span>
        <!--<button [routerLink]="['/keyword', keyword.id]" class="inline-flex items-center my-2 px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400" *ngIf="results.titles.count > 5">Mehr anzeigen</button>-->
      </div>
      <ul
        role="list"
        class="
          grid grid-cols-3
          gap-x-4 gap-y-8
          sm:grid-cols-6 sm:gap-x-6
          lg:grid-cols-8
          xl:gap-x-8
        "
      >
        <li
          [routerLink]="['/img', img.id]"
          *ngFor="let img of results.titles.data"
        >
          <div
            class="
              group
              block
              w-full
              aspect-w-10 aspect-h-7
              shadow-xl
              rounded-lg
              bg-gray-100
              focus-within:ring-2
              focus-within:ring-offset-2
              focus-within:ring-offset-gray-100
              focus-within:ring-blue-500
              overflow-hidden
            "
          >
            <img
              class="object-cover pointer-events-none group-hover:opacity-75"
              [src]="imgRoot + img?.file_name"
              alt=""
            />
          </div>
          <span>{{ img?.title }}</span>
        </li>
      </ul>
    </div>
    <div *ngIf="results && results.fulltext && results.fulltext.count > 0 && results.fulltext.data?.length > 0">
      <div class="mt-12">
        <h2 class="text-2xl lg:text-4xl mb-4 text-blue-800">Volltextsuche</h2>
        &nbsp;
        <span class="text-gray-500" style="position: relative; top: 26px"
          >({{ results.fulltext.count }}
          <span *ngIf="results.fulltext.count != 1">Bilder</span>
          <span *ngIf="results.fulltext.count == 1">Bild</span>)
        </span>
        <!--<button [routerLink]="['/keyword', keyword.id]" class="inline-flex items-center my-2 px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400" *ngIf="results.fulltext.count > 5">Mehr anzeigen</button>-->
      </div>
      <ul
        role="list"
        class="
          grid grid-cols-3
          gap-x-4 gap-y-8
          sm:grid-cols-6 sm:gap-x-6
          lg:grid-cols-8
          xl:gap-x-8
        "
      >
        <li
          [routerLink]="['/img', img.id]"
          *ngFor="let img of results.fulltext.data"
        >
          <div
            class="
              group
              block
              w-full
              aspect-w-10 aspect-h-7
              shadow-xl
              rounded-lg
              bg-gray-100
              focus-within:ring-2
              focus-within:ring-offset-2
              focus-within:ring-offset-gray-100
              focus-within:ring-blue-500
              overflow-hidden
            "
          >
            <img
              class="object-cover pointer-events-none group-hover:opacity-75"
              [src]="imgRoot + img?.file_name"
              alt=""
            />
          </div>
          <span>{{ img?.title }}</span>
        </li>
      </ul>
    </div>
    <div
      *ngIf="
        results &&
        results.ships.length === 0 &&
        results.places.length === 0 &&
        results.events.length === 0 &&
        results.keywords.length === 0 &&
        results.titles.count == 0 &&
        results.fulltext.count == 0
      "
    >
      Keine Ergebnisse gefunden...
    </div>
  </div>
</div>
